import React from 'react';
import { Route, Switch, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../components/PageHeader';
import { useFlairBreadcrumbHook } from '../../../../hooks/useFlairBreadcrumbHook';
import { routes } from '../../routes';
import { CalibrationSessionList } from './CalibrationSessionList/CalibrationSessionList';
import { CalibrationWorkspace } from './CalibrationWorkspace/CalibrationWorkspace';

const CalibrationWorkspaceRoute: React.FC = () => {
  const { sessionId } = useParams<{ sessionId: string }>();
  return <CalibrationWorkspace sessionId={sessionId} />;
};

export const CalibrationPage: React.FC = () => {
  const { t } = useTranslation();

  useFlairBreadcrumbHook([
    { label: t('navigation.menuItems.personalDevelopment.title') },
    { label: t('performanceReview.calibration.title') },
  ]);

  return (
    <Switch>
      <Route
        exact
        path={routes.calibration.route.template()}
        render={() => (
          <>
            <PageHeader title={t('performanceReview.calibration.title')} />
            <CalibrationSessionList />
          </>
        )}
      />
      <Route
        exact
        path={routes.calibrationWorkspace.route.template()}
        component={CalibrationWorkspaceRoute}
      />
    </Switch>
  );
};
